import React from "react";
import cx from "classnames";
import DOMPurify from "dompurify";

import "./BreakdownImportantMessage.scss";

interface IBreakdownImportantMessageProps {
  title: string;
  content: string;
  isPrintView?: boolean;
}

const BreakdownImportantMessage: React.FC<
  React.PropsWithChildren<IBreakdownImportantMessageProps>
> = (props) => (
  <div
    className={cx("c-breakdown-important-message", {
      "c-breakdown-important-message--print": props.isPrintView,
    })}
  >
    <div className="c-breakdown-important-message__title">{props.title}</div>
    <div
      className="c-breakdown-important-message__content"
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(props.content),
      }}
    />
  </div>
);

export default BreakdownImportantMessage;
